import utils from '@/util'
import {
  isBlockExist, defaultHeadingText, hasTag, hasType, generateBlockId,
  generateBlockHash,
} from './common'

const imageLayoutThumbnail = require('@/assets/images/content-slide-layouts/layout_image.svg')

const defaultHeadingStyle = {
  width: '1200px',
  height: '80px',
  minHeight: '80px',
  transform: 'translate(30px, 10px)',
}
const defaultImageStyle = {
  width: '600px',
  height: '400px',
  transform: 'translate(330px, 105px)',
}
const defaultCaptionStyle = {
  width: '800px',
  height: '70px',
  minHeight: '70px',
  transform: 'translate(230px, 520px)',
}

const headingContent = (headingText) => {
  return {
    value: `
    <p style="text-align: center;" data-mce-style="text-align: center;">
      <span style="font-size: 44px;" data-mce-style="font-size: 44px;">
        <strong>
          ${headingText}
        </strong>
      </span>
    </p>
    `,
  }
}

const captionContent = (captionText) => {
  return {
    value: `
    <p style="text-align: center;" data-mce-style="text-align: center;">
      <span style="font-size: 24px;" data-mce-style="font-size: 24px;">
        ${captionText}
      </span>
    </p>
    `,
  }
}

const imageContent = (src, isPlaceholderImage) => {
  return {
    src,
    isPlaceholderImage,
  }
}

export const centerImageTransform = (width, height) => {
  if (!width || !height) return 'translate(20px, 20px)'
  if (typeof width === 'string' && typeof height === 'string') {
    width = width.replace('px', '')
    height = height.replace('px', '')
  }
  const offsetCoords = { x: -10, y: -10 }
  const canvasWidth = 1280
  const canvasHeight = 720
  const centerX = (canvasWidth - width) / 2 + offsetCoords.x
  const centerY = (canvasHeight - height) / 2 + offsetCoords.y - 45 // make the image go up a little bit, to fit the caption in the canvas
  return `translate(${centerX}px, ${centerY}px)`
}

function layoutBuilder(slideId, currentCanvasBlocks) {
  const newCanvasBlocks = { ...currentCanvasBlocks }
  if (!slideId) {
    slideId = (Math.random() + 1).toString(36).substring(6)
  }

  // Add default block to make layout if not exists

  if (!isBlockExist(currentCanvasBlocks, hasType('Image')) &&
      !isBlockExist(currentCanvasBlocks, hasTag('image'))
  ) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'Image',
      tag: 'image',
      content: imageContent(null, true),
      style: defaultImageStyle,
      h: generateBlockHash(),
    }
  }

  if (!isBlockExist(currentCanvasBlocks, hasTag('heading'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'heading',
      content: headingContent(defaultHeadingText),
      style: defaultHeadingStyle,
      h: generateBlockHash(),
    }
  }

  if (!isBlockExist(currentCanvasBlocks, hasTag('caption'))) {
    const blockId = generateBlockId(slideId)
    newCanvasBlocks[blockId] = {
      id: blockId,
      type: 'RichText',
      tag: 'caption',
      content: captionContent('Click to add caption'),
      style: defaultCaptionStyle,
      h: generateBlockHash(),
    }
  }

  // Modify existing blocks to fit the layout structure
  // TODO: Refactor the code
  if (currentCanvasBlocks) {
    const customImageBlockId = Object.keys(currentCanvasBlocks).find((blockId) => {
      const block = currentCanvasBlocks[blockId]
      return block.type === 'Image' && block.content.src != null
    })
    // If custom image existing in the canvas blocks, then try to make that image in place
    if (customImageBlockId) {
      Object.keys(currentCanvasBlocks).forEach((blockId) => {
        const block = currentCanvasBlocks[blockId]
        if (block.tag === 'heading') {
          const newBlock = {
            ...block,
            id: generateBlockId(slideId),
            style: defaultHeadingStyle,
            hidden: false,
            content: headingContent(utils.extractContent(block.content.value, true) || defaultHeadingText),
            h: generateBlockHash(),
          }
          newCanvasBlocks[newBlock.id] = newBlock
          delete newCanvasBlocks[blockId]
        } else if (blockId === customImageBlockId) {
          const newBlock = {
            ...block,
            id: generateBlockId(slideId),
            hidden: false,
            content: imageContent(block.content.src, false),
            style: {
              width: block.style.width,
              height: block.style.height,
              transform: centerImageTransform(block.style.width, block.style.height),
            },
            h: generateBlockHash(),
          }
          newCanvasBlocks[newBlock.id] = newBlock
          delete newCanvasBlocks[blockId]
        } else {
          newCanvasBlocks[blockId] = {
            ...block,
            hidden: true,
          }
        }
      })
      // If no custom image is found, then set the image placeholder visible
    } else {
      Object.keys(currentCanvasBlocks).forEach((blockId) => {
        const block = currentCanvasBlocks[blockId]
        if (block.tag === 'heading') {
          const newBlock = {
            ...block,
            id: generateBlockId(slideId),
            style: defaultHeadingStyle,
            hidden: false,
            content: headingContent(utils.extractContent(block.content.value, true) || defaultHeadingText),
            h: generateBlockHash(),
          }
          newCanvasBlocks[newBlock.id] = newBlock
          delete newCanvasBlocks[blockId]
        } else if (block.tag === 'image') {
          const newBlock = {
            ...block,
            id: generateBlockId(slideId),
            hidden: false,
            content: imageContent(null, true),
            style: {
              width: block.style.width,
              height: block.style.height,
              transform: centerImageTransform(block.style.width, block.style.height),
            },
            h: generateBlockHash(),
          }
          newCanvasBlocks[newBlock.id] = newBlock
          delete newCanvasBlocks[blockId]
        } else {
          newCanvasBlocks[blockId] = {
            ...block,
            hidden: true,
          }
        }
      })
    }
  }

  return newCanvasBlocks
}

const ImageLayout = {
  type: 'image',
  name: 'Image',
  layoutThumbnailImage: imageLayoutThumbnail,
  build: layoutBuilder,
}

export default ImageLayout
